import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'

export const OneTrustConsent = ({
  loadScript = true,
  testDomainScript = '9470b86f-5b87-4646-a4f7-2f2916b2a883-test',
  domainScript = '9470b86f-5b87-4646-a4f7-2f2916b2a883',
}) => {
  useEffect(() => {
    const handleConsentUpdate = () => {
      const groups = window.OptanonActiveGroups || ''

      const performanceConsent = groups.includes('C0002') ? 'granted' : 'denied'
      const targetingConsent = groups.includes('C0004') ? 'granted' : 'denied'

      window.gtag?.('consent', 'update', {
        ad_storage: targetingConsent,
        analytics_storage: performanceConsent,
      })
    }

    if (typeof window !== 'undefined') {
      window.OptanonWrapper = () => {
        window.Optanon?.OnConsentChanged(handleConsentUpdate)
      }
    }
  }, [])

  if (typeof window !== 'undefined') {
    const isStageEnv =
      window.location.href.indexOf('stage.crunchyroll.com') > -1

    const isDevEnv = window.location.href.indexOf('dev.crunchyroll.com') > -1

    const otScript = isStageEnv || isDevEnv ? testDomainScript : domainScript

    if (loadScript) {
      return (
        <Helmet>
          <script
            src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
            data-document-language="true"
            type="text/javascript"
            charset="UTF-8"
            data-domain-script={otScript}
          ></script>
          <script type="text/javascript">{`
          function OptanonWrapper() { }
        `}</script>
        </Helmet>
      )
    } else {
      return null
    }
  } else {
    return null
  }
}

OneTrustConsent.propTypes = {
  loadScript: PropTypes.bool,
  domainScript: PropTypes.string,
}
